import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { AuditLogsTab } from "@/components/admin/AuditLogsTab";

/**
 * Admin-only standalone page for browsing admin_audit_logs.
 * Access is gated by <AdminRoute> in App.tsx and by the
 * "Admins view audit logs" RLS policy on admin_audit_logs.
 */
export default function AdminAuditLogs() {
  return (
    <div className="container mx-auto max-w-7xl px-4 py-8">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold">Admin audit logs</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Filter by table, actor, and time range.
          </p>
        </div>
        <Button variant="outline" asChild>
          <Link to="/admin">
            <ChevronLeft className="size-4 mr-2" />
            Back to Admin
          </Link>
        </Button>
      </div>
      <AuditLogsTab />
    </div>
  );
}
